/**
 * 设置脱敏规则
 * 账号、姓名、证件号：<=4位长度，则显示最后一位；>4位长度，显示前两位和后一位；
 * 手机号码：显示前三位和后三位
 * 邮箱：显示前两位，@后面全显示
 *
 * demo:
 * 在接口获取完信息数据之后，使用this.$nextTick()，确保数据已更新再进行脱敏
 * this.$nextTick(()=>{getDataSetSensitive('你自定义的类名')})
 *
 * 页面上的el-input加入自定义类名，如class="sensitiveClass"，则执行上面方法时入参为"sensitiveClass"
 *
 * setSensitive、recoverData为el-input @blur和@focus的方法（看是否需要使用）
 * PS注意：这两个方法页面import引入之后，需要在method声明一下才可以在HTML上使用
 * methods:{
 *     setSensitive,
 *     recoverData
 * },
 *
 * HTML:
 * @focus="(e)=>recoverData(e,this,'form','name')"   <==== form 为表单:model值，name为具体数据字段（此方法只针对表单，普通无表单输入框自己写@focus清空即可）
 * @blur="(e)=>setSensitive(e)"
 * */
 export function sensitiveField(field, before, after) {
	if (!field) {
		return '';
	}
	field = String(field);

	//内容为手机号码
	const phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
	//内容为邮箱
	var emailReg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;

	if (field.length === 11 && phoneReg.test(field)) {
		before = 3;
		after = 3;
	} else if (emailReg.test(field)) {
		before = 2;
		after = 3
	} else if (field.length <= 4) {
		before = 0;
		after = 1;
	} else {
		before = 2;
		after = 1;
	}

	// 匹配中文、英文、数字
	const regItem = '[\u4e00-\u9fa5a-zA-Z0-9]';
	const regExp = `(${regItem}{${before}})${regItem}*(${regItem}{${after}})`;
	const reg = new RegExp(regExp);

	return field.replace(reg, '$1*****$2');
}

//失焦后再进行脱敏处理
export function setSensitive(e) {
	if (!e.target.value) return false;
	e.target.value = sensitiveField(e.target.value);
}

//聚焦输入框后，判断是否为脱敏数据，如果不是脱敏数据则不清空
export function recoverData(event, arg, formName, name) {
	let value = event.target.value;
	if (value.indexOf("*****") > -1) {
		let arr = formName.split('.');
		let obj;
		for (let i of arr) {
			obj = obj ? obj[i] : arg[i]
		}
		obj[name] = ""
	}
}

//获取动态数据之后对页面进行脱敏操作 c-类名
export function getDataSetSensitive(c) {
	//获取页面类名
	let classArr = document.getElementsByClassName(c);
	//遍历页面dom结构
	for (let i = 0; i < classArr.length; i++) {
		//获取el-input子节点
		let input_dom = classArr[i].children[0];
		input_dom.value = sensitiveField(input_dom.value);
	}
}

